import { MouseEventHandler } from "react";

import { faEdit, faTrashCan } from "@fortawesome/pro-regular-svg-icons";

import { RawCell } from "src/dataTable/RawCell";
import { IconButton } from "src/design-system/Icon";
import { Tooltip } from "src/design-system/Tooltip";

type Props = {
  onEditClick: MouseEventHandler;
  onDeleteClick: MouseEventHandler;
};

export const ApiKeyActions: React.FC<Props> = ({
  onEditClick,
  onDeleteClick,
}) => {
  const actions = (
    <div className="flex items-center justify-end gap-x-2">
      <Tooltip placement="top" title="Rename" asChild>
        <IconButton icon={faEdit} size="xs" onClick={onEditClick} />
      </Tooltip>
      <Tooltip placement="top" title="Delete" asChild>
        <IconButton icon={faTrashCan} size="xs" onClick={onDeleteClick} />
      </Tooltip>
    </div>
  );

  return (
    <RawCell
      cell={actions}
      classNameOverrides="min-h-[48px] invisible flex items-right justify-end group-hover:visible max-w-0"
    />
  );
};
